export const ROUTES = {
  PROGRAM_RESERVE: '/settlement/program-funding',
  MANUAL_ENTRY: '/settlement/program-funding/manual-entry',
  BULK_ENTRY: '/settlement/program-funding/bulk-entry',
};
